import { ProjectMember } from '@ih/app/shared/apis/interfaces';

export class SetProjects {
  public static readonly type = '[User/Projects] SetProjects';
  constructor(public readonly projectMember: ProjectMember[]) {}
}
